<template>
    <v-dialog
        v-model="show"
        scrollable
        width="500"
        content-class="rounded-lg"
    >
        <v-card>
            <v-toolbar height="52" flat outlined>
                <v-toolbar-title>{{ title }}</v-toolbar-title>
            </v-toolbar>
            <v-card-text class="pa-4">
                <v-form ref="form" v-model="valid">
                    <v-row>
                        <v-col cols="auto">
                            <v-checkbox
                                color="var(--primary-color, #1976d2)"
                                dense
                                @change="checkApplicant"
                                label="신청자와 동일"
                                hide-details="auto"
                                class="ma-0 pa-0"
                            ></v-checkbox>
                        </v-col>
                        <v-col cols="auto" v-if="isVipEnable">
                            <v-checkbox
                                dense
                                v-model="visitor.vip"
                                true-value="Y"
                                false-value="N"
                                label="VIP"
                                hide-details="auto"
                                class="ma-0 pa-0"
                            ></v-checkbox>
                        </v-col>
                    </v-row>
                    <v-text-field
                        v-model="visitor.visitorName"
                        :rules="[ rules.name ]"
                        counter="25"
                        maxlength="25"
                        required
                        label="성명 *"
                        class="mt-3"
                    ></v-text-field>
                    <v-text-field
                        v-model="visitor.visitorMobile"
                        :rules="[ rules.mobile ]"
                        @keyup="changeMobile(visitor.visitorMobile)"
                        counter="13"
                        maxlength="13"
                        required
                        label="휴대폰 *"
                    ></v-text-field>
                    <v-text-field
                        v-model="visitor.visitorCompany"
                        :rules="[ rules.company ]"
                        counter="25"
                        maxlength="25"
                        required
                        label="업체 *"
                    ></v-text-field>

                    <date-field
                        v-if="$code.get('service.config.use_birthday') === 'Y'"
                        v-model="visitor.visitorBirthday"
                        required
                        label="생년월일 *"
                        :max="new Date().toISOString().substr(0, 10)"
                        min="1910-01-01"
                        active-picker="YEAR"
                        :rules="[ rules.birthday ]"
                    />

                    <v-text-field
                        v-model="visitor.visitorCarNumber"
                        counter="8"
                        maxlength="8"
                        label="차량번호"
                        hint="예: 12가8282, 825서 1212"
                    ></v-text-field>

                    <div>전기차, 대형 RV, SUV는 외부주차장 이용 부탁드립니다</div>
                </v-form>
            </v-card-text>

            <v-footer outlined
                      height="50"
                      color="#fff"
                      class="px-2 justify-center"
            >
                <v-row justify="end" align="center" no-gutters>
                    <v-col cols="auto">
                        <v-btn
                            depressed
                            class="secondary-btn"
                            @click="cancel()"
                        >
                            취소
                        </v-btn>
                        <v-btn
                            depressed
                            width="100"
                            class="ml-2 primary-btn"
                            :disabled="!valid"
                            @click="submit()"
                        >
                            확인
                        </v-btn>
                    </v-col>
                </v-row>
            </v-footer>
        </v-card>
    </v-dialog>
</template>

<script>
import utilService from "@/service/utilService";
import cookie from "@/service/cookieUtil";
import DateField from "@/components/DateField";

export default {
    name: 'RegistVisitorDialog',

    props: {
        value: {
            type: Boolean,
            required: true
        },

        agent: {
            type: Object
        },

        targetVisitor: {
            type: Object,
            default: () => ({})
        }
    },

    components: {
        DateField: DateField,
    },

    data: () => ({
        show: false,
        valid: false,
        dateMenu: false,
        birthdayMenu: false,
        title: null,
        hasAccessToken: false,

        defaultData: {
            visitorId: null,
            visitorName: null,
            visitorMobile: null,
            visitorCompany: null,
            visitorBirthday: null,
            visitorCarNumber: null,
            purpose: null,
            vip: 'N',
        },

        visitor: {
            visitorId: null,
            visitorName: null,
            visitorMobile: null,
            visitorCompany: null,
            visitorBirthday: null,
            visitorCarNumber: null,
            purpose: null,
            vip: 'N',
        },

        rules: {
            name: v => !!v || '성명을 입력하세요',
            mobile: v => utilService.validateMobile(v),
            company: v => !!v || '업체를 선택하세요',
            birthday: v => !!v || '생년월일을 선택하세요',
            carNumber: v => utilService.validateCarNum(v),
            purpose: v => !!v || '방문 목적을 선택하세요',
        },

        purposes: [],
    }),

    created() {

    },

    computed: {
        isVipEnable() {
            return !!cookie.get('access_token');
        },

        isEditMode() {
            return this.targetVisitor ? true : false;
        },
    },

    watch: {
        birthdayMenu(val) {
            val && setTimeout(() => (this.$refs.birthdayPicker.activePicker = 'YEAR'))
        },

        show(val) {
            this.$emit('input', val);
        },

        value(val) {
            this.show = val;

            if (val) {
                if (this.isEditMode) {
                    this.title = '방문자 수정';
                    this.$nextTick(() => {
                        this.visitor = {... this.targetVisitor }
                    })
                } else {
                    this.title = '방문자 등록';
                    this.visitor = {
                        ...this.defaultData,
                        visitorId: utilService.uuid()
                    }
                }

                if (this.$refs.form) {
                    this.$refs.form.resetValidation();
                }
            } else {
                this.close();
            }
        }
    },

    methods: {
        _reset() {
            Object.assign(this.visitor, this.defaultData);

            // Form validation initialize
            if (this.$refs.form) this.$refs.form.reset();
        },

        changeMobile(str) {
            this.visitor.visitorMobile = utilService.humanReadableMobile(str);
        },

        checkApplicant(isAgent) {
            if (isAgent) {
                this.visitor = {
                    ...this.visitor,
                    visitorName: this.agent.agentName,
                    visitorMobile: this.agent.agentMobile,
                    visitorCompany: this.agent.agentCompany
                };
            }
        },

        submit() {
            this.$emit('save', { ...this.visitor });
            this.close();
        },

        cancel() {
            this.close();
        },

        close() {
            this._reset();
            this.$emit('close');
        },
    }

}
</script>

<style scoped>

</style>